import { CSSProperties } from 'react'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15
  } as CSSProperties,
  headers: {
    fontSize: 30,
    textAlign: 'left',
    color: '#64004D'
  } as CSSProperties,
  paragraph: {
    fontSize: 20
  } as CSSProperties,
  bold: {
    fontWeight: 'bold'
  } as CSSProperties,
  list: {
    fontSize: 14
  } as CSSProperties,
  underline: {
    textDecoration: 'underline'
  } as CSSProperties
}

export default styles
